const columns = [
  { name: "Usuário", value: "userName", filter: false },
  { name: "Nome do material", value: "materialName", filter: false },
  { name: "Tempo", value: "time", filter: false },
  { name: "Data", value: "convertDate", filter: false },
  { name: "Turma", value: "classroomName", filter: false },
];

export { columns };
